import { FpTheme } from '@flicent/fieldpulse-react-component-library-frontend';

import { JobApiService } from './job-api.service';
import MetaDataPublicLink from '../interfaces/meta-data-public-link.interface';


interface Response {
  meta: MetaDataPublicLink;
  theme: FpTheme;
}

export const getPublicLinkJobMetaRequest = (publicLinkId: string): Promise<Response> => {
  return JobApiService.makeRequest<Response>(`/public/${ publicLinkId }`);
};